import type { ApiNotification } from '@izimi/api';

export const sortNotifications = (notifications: ApiNotification[]) =>
  [...notifications].sort((a, b) => Number(new Date(b.timestamp)) - Number(new Date(a.timestamp)));
